import { useMutation } from "@tanstack/react-query";
import { toast } from "@components/toast/Toast";
import api from "./api";

async function getNote(id) {
  const response = await api.get(`api/notes/${id}`);
  return response.data;
}

async function createNote(content, paymentRequestId, customerId) {
  try {
    const response = await api.post(
      `api/notes`,
      {
        content,
        paymentRequestId,
        customerId
      },
    );

    return response.data;
  } catch (error) {
    return [];
  }
}

// A plain, user-authored note with optional colleague mentions — straight to customers-service via the
// BFF's NotesController. Deliberately independent of the AI chat / intelligence-service: no conversation,
// no thread, no AI-suggestion attribution. mentionedUserIds are the colleagues to notify; the BFF resolves
// them against the merchant's users.
async function createCustomerNote({ customerId, content, mentionedUserIds }) {
  const { data } = await api.post("api/notes", {
    customerId,
    content,
    mentionedUserIds,
  });
  return data; // NoteDto
}

function useCreateNote() {
  return useMutation({
    mutationFn: createCustomerNote,
    onSuccess: () => toast({ description: "Note added" }),
    onError: () => toast({ description: "Couldn’t save note. Please try again." }),
  });
}

export {
  createNote,
  getNote,
  createCustomerNote,
  useCreateNote,
};

export default {
  createNote,
  getNote,
};
